"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>FilterChipBar
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const index_cjs_namespaceObject = require("../../Carousel/index.cjs");
const external_FilterChip_index_cjs_namespaceObject = require("../../FilterChip/index.cjs");
function FilterChipBar({ filterChipData, handleFilterChipClick, selectedFilterChipData }) {
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: "p-2",
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Carousel, {
            carouselId: "autocomplete-filter-bar",
            dragFree: true,
            slideWidth: "auto",
            slides: filterChipData.map((item)=>({
                    childrenNodes: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_FilterChip_index_cjs_namespaceObject.FilterChip, {
                        label: item.name,
                        onClick: (e, selected)=>{
                            e?.stopPropagation();
                            e?.preventDefault();
                            handleFilterChipClick(item, selected ?? false);
                        },
                        selected: selectedFilterChipData.has(`${item.filterType}_${item.code}_${item.name}`)
                    }),
                    id: item.code
                })),
            type: "content",
            slotClassNames: {
                containerClass: 'gap-1'
            }
        })
    });
}
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
